import { render, staticRenderFns } from "./SaleReportLaba.vue?vue&type=template&id=2f6f2e68&"
import script from "./SaleReportLaba.vue?vue&type=script&lang=js&"
export * from "./SaleReportLaba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports